import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { http, errMsg } from "../lib/api";
import { useDataset, DatasetSelect, PageHead, CorteBadge } from "../lib/lm";
import { useOp, saveBlob } from "../lib/useOp";
import { Btn, Card } from "../components/kit/Kit";
import { LoanLevelTape } from "../components/lm/LoanLevelTape";

export default function DataTape() {
  const { info, ds, setDs } = useDataset();
  const [v, setV] = useState(null);
  const { run, bar, busy } = useOp("tape-progress");
  useEffect(() => { if (info) http.get("/lm/tape/validacion", { params: { dataset: ds } }).then((r) => setV(r.data)).catch(() => setV(null)); }, [info, ds]);
  const bajar = async (formato) => {
    try { const r = await run(`Data tape ${formato.toUpperCase()}`, (o) => http.get("/lm/tape", { ...o, params: { dataset: ds, formato }, responseType: "blob" })); saveBlob(r.data, `data_tape_${ds}.${formato}`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10" data-testid="datatape-page">
      <PageHead kicker="Reportes y Fondeo" title="Data tape"><CorteBadge iso={info?.cortes?.[ds]} testid="tape-corte" /><DatasetSelect info={info} ds={ds} setDs={setDs} /></PageHead>
      <Card title="Descargar" subtitle="Excel: loan-level tape + 5 tablas Accial + diccionario + validación · ZIP (CSV de las 5 tablas) · PDF resumen">
        <div className="flex flex-wrap gap-2">{["xlsx", "zip", "pdf"].map((f) => <Btn key={f} kind={f === "xlsx" ? "accent" : "secondary"} disabled={busy} onClick={() => bajar(f)} data-testid={`tape-${f}`}><Download size={14} />{f.toUpperCase()}</Btn>)}</div>
        {bar}
      </Card>
      {info && <LoanLevelTape ds={ds} />}
      {v && <Card title="Validaciones Accial (5 tablas)" testid="tape-validacion"><pre className="max-h-96 overflow-auto whitespace-pre-wrap text-xs">{JSON.stringify(v, null, 2)}</pre></Card>}
    </main>
  );
}
